'use client';

import { useTranslation } from '@/i18n/client';
import { eventFilterKeys, FilterItem } from '@/types/filters';
import { WithLang } from '@/types/general';

import SelectFilter from '../elements/select/select-filter';
import { filtersColorMap } from './calendar-constants';
import CalendarFilterLabel from './calendar-filter-label';
import { FiltersProps } from './calendar-types';

export default function CalendarFiltersDesktop(props: WithLang<FiltersProps>) {
    const { t } = useTranslation(props.lang, 'filters');

    return (
        <div className="my-6">
            <div className="mr-auto grid max-w-7xl grid-cols-2 grid-rows-2 gap-2 lg:grid-cols-4 lg:grid-rows-1">
                {eventFilterKeys.map((fKey) => (
                    <SelectFilter
                        selectType={fKey === 'price' || fKey === 'language' ? 'select' : 'input'}
                        lang={props.lang}
                        key={fKey}
                        defaultValue={t(`${fKey}`, { count: props.filtersSelected[fKey].length })}
                        options={props.filtersAvailable[fKey]}
                        onClick={(item: FilterItem) => props.handleAddFilter(item)}
                    />
                ))}
            </div>
            {props.filtersSelectedCount > 0 && (
                <div className="mt-4 flex max-w-fit flex-wrap gap-3">
                    <>
                        {eventFilterKeys.map((fKey) => (
                            <CalendarFilterLabel
                                lang={props.lang}
                                key={fKey}
                                className={filtersColorMap[fKey]}
                                options={props.filtersSelected[fKey]}
                                onRemove={props.handleRemoveFilter}
                            />
                        ))}
                        <div onClick={props.onReset} className="flex cursor-pointer items-center gap-1">
                            <button className="text-base">{t('reset')}</button>
                            <span className="icon h-[10px] w-[10px] bg-phiX" />
                        </div>
                    </>
                </div>
            )}
        </div>
    );
}
